const Vue = require("vue").default
const $ = require("jquery")
const BootstrapVue = require("bootstrap-vue").default
const genericModal = require("../../views/interface/genericModal.vue").default

Vue.use(BootstrapVue)

Vue.config.devtools = false

function newVueModal({randomID, modalBodyID, modalTitle, modalSize} = {}) {
  generateElement({elementID: randomID})
  window.newVueModal = new Vue({
    el: `#${randomID}`,
    render: h =>
      h(genericModal, {
        props: {
          modalBodyID,
          modalTitle,
          modalSize,
        },
      }),
  })
  return window.newVueModal
}

function generateElement({elementID}) {
  let newElement = `<div id='${elementID}'></div>`
  $(".active-window").prepend(newElement)
}

module.exports = {newVueModal}
